import { connect } from 'react-redux'
import { compose } from 'recompose';
import Message from '../components/message';
import {resetMessages} from '../store/actions/messages';

const mapStateToProps = (state) => {
    return {
        messages: state.messages
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetMessages: () => dispatch(resetMessages())
    }
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
)(Message);
 


// WEBPACK FOOTER //
// ./src/containers/MessageContainer.js